import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { DocumentDao } from '@app/dao/document/document.dao';

import { HttpErrorResponse } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UserAuthentified } from '@app/authentification/user-authentified.interface';
import { UserDao } from '@app/dao/user/user.dao';
import { PledgeRead } from '@app/forms/subscription/definition/interface/Pledge';
import { CompanyFieldType } from '@app/forms/subscription/definition/interface/enum';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  EMPTY,
  Observable,
  Subject,
  throwError,
  catchError,
  delay,
  finalize,
  map,
  switchMap,
  take,
  takeWhile,
  tap,
} from 'rxjs';

import { getDocumentRoute, resetDocumentForm } from '../utile';
import { EaDocumentFormBuilder } from './ea-subscription-form.builder';
import { AuthentificationService } from '@app/authentification/authentification.service';
const DOCUMENT_TYPE = 'JUSTIFICATIF_ORIGINE_DES_FONDS';
@UntilDestroy()
@Component({
  selector: 'justificatif-origine-des-fonds-form',
  templateUrl: './justificatif-origine-des-fonds-form.component.html',
  styleUrls: ['./justificatif-origine-des-fonds-form.component.scss'],
  standalone: false,
})
export class JustificatifOrigineDesFondsFormComponent
  extends EaDocumentFormBuilder
  implements OnInit
{
  files: File[] = [];

  file: any;

  error: string;

  user: UserAuthentified;
  private alive = true;
  documents: any;
  docLoading: boolean = false;

  doneSubject: Subject<void> = new Subject<void>();
  obser$: any;
  formData: any;

  documentId: any;
  submitting: boolean;
  resetFiles: boolean = false;
  pledge: PledgeRead;
  JUSTIFICATIF_REQUIRED: boolean;
  safeUrl: SafeResourceUrl = '';

  displayDocumentLoading: boolean = false;

  gedDocuments = [DOCUMENT_TYPE];

  constructor(
    protected formConstructor: PrFormConstructor,
    private documentDao: DocumentDao,
    protected authenticationService: AuthentificationService,
    protected subscriptionFacade: SubscriptionFacadeService,
    private userDao: UserDao,
    private cdr: ChangeDetectorRef,
    private httpApiService: HttpApiService,
    private sanitizer: DomSanitizer,
  ) {
    super(formConstructor, subscriptionFacade, authenticationService);
  }

  ngOnInit() {
    this.pledge = this.subscriptionFacade.getPledge();
    this.JUSTIFICATIF_REQUIRED =
      this.pledge?.parameters?.additionalQuestions?.find(
        q => q?.id === CompanyFieldType.JUSTIFICATIF_ORGINE_DES_FONDS_DOCUMENT,
      )?.required === 'MANDATORY';

    this.submitting = false;
    this.loading = true;
    this.initForm(
      {
        document: DOCUMENT_TYPE,
      },
      { ...this.pledge?.parameters },
    );
    this.obser$ = this.userDao.getAuthentified().pipe(
      switchMap(user => {
        this.user = user;

        return this.documentDao.searchDocument(user.accountId, {
          documents: [DOCUMENT_TYPE],
        });
      }),
      takeWhile(() => this.alive),
      map((resp: any) => {
        return resp.filter(doc => doc.document === DOCUMENT_TYPE) || {};
      }),
      tap(resp => {
        this.documents = resp;
        let doc = resp[0];
        if (doc) {
          doc = { ...doc };
        }
        this.initForm(
          doc || {
            document: DOCUMENT_TYPE,
            parameters: { ...this.pledge?.parameters },
          },
          { ...this.pledge?.parameters },
        );
        return resp;
      }),
      tap(() => {
        this.displayDocument().subscribe();
      }),
      take(1),
      catchError(err => {
        this.loading = false;
        return err;
      }),
      finalize(() => {
        this.loading = false;
        this.cdr.detectChanges();
      }),
    );
  }

  onLoadFiles(files: any) {
    this.cdr.detectChanges();
    this.files = files;
    if (this.files.length > 0) {
      this.error = null;
    }
  }

  get title() {
    return 'Ajoutez un nouveau document';
  }
  downloadDocument(doc) {
    this.docLoading = true;
    const route = getDocumentRoute(doc.id, this.user?.accountId);
    this.httpApiService
      .getWithOptions(route, {
        responseType: 'arraybuffer',
      })
      .pipe(
        take(1),
        finalize(() => {
          this.docLoading = false;
        }),
      )
      .subscribe(resp => {
        var blob = new Blob([resp], { type: 'application/pdf' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `${doc.label}.pdf`;
        link.click();

        this.docLoading = false;

        this.cdr.detectChanges();
      });
  }

  deleteDocument(doc) {
    const route = getDocumentRoute(doc.id, this.user?.accountId);
    this.httpApiService
      .delete(route)
      .pipe(take(1))
      .subscribe(() => {
        this.documents = this.documents.filter(d => d.id !== doc.id);
        resetDocumentForm(this, DOCUMENT_TYPE);
        this.cdr.detectChanges();
      });
  }

  withdraw(doc) {
    this.documents = this.documents.filter(d => d.id !== doc.id);
    resetDocumentForm(this, DOCUMENT_TYPE);
    this.cdr.detectChanges();
  }

  onSubmit() {}
  saveDocuments() {
    this.form.markAsDirty();
    if (!this.submitting) {
      this.submitting = true;
    }

    if (!this.files.length && !this.documents.length) {
      if (this.JUSTIFICATIF_REQUIRED) {
        this.error = 'Veuillez saisir au moins un fichier';
        return;
      }
      this.subscriptionFacade.nextStep();
      return;
    } else if (this.files.length > 0) {
      this.prFormService.loading();
      const formData = new FormData() as any;
      for (const file of this.files) {
        formData.append('documentsFiles', file);
      }

      const obj = this.extractDocument().getRawValue();

      const payloadDocument = this.formatPayloadForSubmitDocument(obj);

      formData.append(
        'document',
        new Blob([JSON.stringify(payloadDocument)], {
          type: 'application/json',
        }),
      );

      this.formData = formData;
      this.resetFiles = false;

      return this.onSave();
    }
  }

  private formatPayloadForSubmitDocument(payload: any) {
    return {
      label: payload.label,
      dateCreated: payload.dateCreated,
      reviewed: payload.reviewed,
      isSigned: payload.isSigned,
      accountId: payload.accountId,
      category: payload.category,
      dateExpired: payload.dateExpired,
      document: payload.document,
      id: payload.id,
      ownerIds:
        payload.ownerIds && payload.ownerIds.length
          ? payload.ownerIds
          : payload.ownerIds
            ? [payload.ownerIds]
            : [],
    };
  }

  private errorSaved(errors: any) {
    this.submitting = false;
    console.error(errors);
    this.prFormService.loaded();
    this.notificationService.error('La sauvegarde a échoué');
    this.cdr.detectChanges();
  }

  private successSaved(success: any) {
    this.documents.push(success);

    this.form.reset();
    this.resetFiles = true;

    this.initForm({
      document: DOCUMENT_TYPE,
    });
  }

  next() {
    if (!this.files.length && !this.documents.length) {
      if (this.JUSTIFICATIF_REQUIRED) {
        this.error = 'Veuillez saisir au moins un fichier';
        return;
      }
      this.subscriptionFacade.submitPledgeWithoutForm(this);

      return;
    }
    if (!this.files.length && !this.documents.length) {
      this.error = 'Veuillez saisir au moins un fichier';
    }
    if (!this.saveDocuments()) {
      this.subscriptionFacade.submitPledgeWithoutForm(this);
    }
    this.saveDocuments()?.subscribe(
      success => {
        this.successSaved(success);

        this.submitting = false;
        this.prFormService.loaded();
        this.doneSubject.next();
        this.cdr.detectChanges();
        if (this.documents.length) {
          this.subscriptionFacade.submitPledgeWithoutForm(this);
        }
      },
      errors => {
        this.errorSaved(errors);
      },
    );
  }

  onSave() {
    return this.createDocument(this.formData);
  }

  updateDocument() {
    return this.documentDao
      .putDocument(this.extractDocument().getRawValue(), this.user.accountId)
      .pipe(
        take(1),
        tap(resp => {
          this.documentId = resp.id;
        }),
      );
  }
  createDocument(formData) {
    return this.documentDao.saveDocument(formData, this.user.accountId).pipe(
      take(1),
      tap(resp => {
        this.documentId = resp.id;
      }),
    );
  }
  extract() {
    const ids = this.documents.map(doc => doc.id);
    return {
      proofOfFundsOriginIds: ids,
    };
  }

  onGedDocumentSelected(doc: any) {
    if (!doc?.id || (this.documents || []).some(d => d.id === doc.id)) {
      return;
    }

    this.documents = [...(this.documents || []), doc];
    this.error = null;
    this.safeUrl = '';
    this.initForm(
      {
        ...doc,
        document: DOCUMENT_TYPE,
        parameters: { ...this.pledge?.parameters },
      },
      { ...this.pledge?.parameters },
    );
    this.displayDocument().subscribe();
    this.cdr.detectChanges();
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
  displayDocument(): Observable<any> {
    if (!this.entity?.id) {
      return EMPTY;
    }
    this.displayDocumentLoading = true;
    const doc = this.entity;

    const route = getDocumentRoute(doc.id, this.user?.accountId);

    this.httpApiService.getWithOptions(route, {
      responseType: 'arraybuffer',
    });

    return this.httpApiService
      .getWithOptions(route, {
        responseType: 'arraybuffer',
      })
      .pipe(
        untilDestroyed(this),
        take(1),
        delay(1000),
        tap((documentContent: ArrayBuffer) => {
          this.createIFrame(documentContent);
        }),
        catchError((error: HttpErrorResponse) => {
          console.error(error);
          this.displayDocumentLoading = false;
          return throwError(error);
        }),
        finalize(() => {
          this.displayDocumentLoading = false;
        }),
      );
  }
  createIFrame(resp) {
    let blob = new Blob([resp], { type: 'application/pdf' });
    let dataUrl = window.URL.createObjectURL(blob);

    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(dataUrl);

    this.displayDocumentLoading = true;
  }
}
